import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";

export default function EditCard() {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const cardId = searchParams.get("id");

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  const [form, setForm] = useState({
    title: "",
    description: "",
    url: "",
    position: 1,
    image: null,
    taxonomy: "courses",
    button_text: "",
  });

  const [currentImage, setCurrentImage] = useState("");

  useEffect(() => {
    if (cardId) {
      fetchCard();
    }
  }, [cardId]);

  const fetchCard = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/cards/${cardId}`,
      );

      const card = response.data.data || response.data;

      setForm({
        title: card.title || "",
        description: card.description || "",
        url: card.url || "",
        position: card.position || 1,
        taxonomy: card.taxonomy || "courses",
        button_text: card.button_text || "",
        image: null,
      });

      setCurrentImage(card.image || "");
    } catch (error) {
      console.error(error);
      setMessage("Failed to load card.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      setForm((prev) => ({
        ...prev,
        [name]: files[0],
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");

    try {
      const formData = new FormData();

      formData.append("title", form.title);
      formData.append("description", form.description);
      formData.append("url", form.url);
      formData.append("position", form.position);
      formData.append("taxonomy", form.taxonomy);
      formData.append("button_text", form.button_text);

      if (form.image) {
        formData.append("image", form.image);
      }

      formData.append("_method", "PUT");

      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/cards/${cardId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      alert("Card updated successfully");
      navigate("/xl-admin/cards");
    } catch (err) {
      console.error(err);

      setMessage(err.response?.data?.message || "Failed to update card.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container">
        <div className="d-flex justify-content-center mt-4">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="mb-4 d-flex justify-content-between align-items-center">
        <h3 className="mb-0">Edit Card</h3>
      </div>

      {message && <div className="alert alert-info">{message}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Title</label>
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea
            name="description"
            value={form.description}
            onChange={handleChange}
            className="form-control"
            rows="4"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">URL</label>
          <input
            type="url"
            name="url"
            value={form.url}
            onChange={handleChange}
            className="form-control"
            placeholder="https://example.com"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Position</label>
          <select
            name="position"
            value={form.position}
            onChange={handleChange}
            className="form-control"
          >
            {[...Array(7).keys()].map((i) => (
              <option key={i} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Taxonomy</label>
          <select
            name="taxonomy"
            value={form.taxonomy}
            onChange={handleChange}
            className="form-control"
          >
            <option value="courses">Courses</option>
            <option value="features">Features</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Button Text</label>
          <input
            type="text"
            name="button_text"
            value={form.button_text}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        {currentImage && (
          <div className="mb-3">
            <label className="form-label d-block">Current Image</label>
            <img
              src={currentImage}
              alt="Card"
              style={{
                maxWidth: "250px",
                maxHeight: "150px",
                objectFit: "cover",
                borderRadius: "6px",
              }}
            />
          </div>
        )}

        <div className="mb-3">
          <label className="form-label">Replace Image</label>
          <input
            type="file"
            name="image"
            className="form-control"
            accept="image/*"
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Updating..." : "Update Card"}
        </button>
      </form>
    </div>
  );
}
